"use strict";
/**
 * AngularJS icon module.
 *
 * @packageDocumentation
 * @module Icon
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
//#region Angular Imports
var angular_1 = tslib_1.__importDefault(require("angular"));
//#endregion
//#region Module Setup
var icon_service_1 = require("./icon.service");
exports.ICON_MODULE_NAME = 'imr.controls.components.icon';
var iconModule = angular_1.default.module(exports.ICON_MODULE_NAME, []);
iconModule.provider(icon_service_1.SERVICE_NAME, icon_service_1.IMRIconServiceProvider);
//#endregion
//# sourceMappingURL=icon.module.js.map